/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row , ButtonToolbar , Modal , Button  , Navbar , Nav , NavDropdown} from 'react-bootstrap'


import BootstrapTable from 'react-bootstrap-table-next';
import FieldGroup from '../FieldGroup.js';


export default class InformationPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            value:this.props.value || ""
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || ""
        };
    }

    onSave(){
        if(this.props.onSave) this.props.onSave();
        this.props.onHide();
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {this.props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            {this.props.children}
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}